export const formatMoney = (value, currencySymbol = '$') => {
    const numeric = Number(value);
    const safe = Number.isFinite(numeric) ? numeric : 0;
    return `${currencySymbol}${safe.toFixed(2)}`;
};
